import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import ListFilter from './ListFilter';
import HotelCategoryFilter from './HotelCategoryFilter';
import TilesFilter from './TilesFilter';
import { FILTER_TYPES } from '../../../../constants/filterConstants';
import RangeFilter from './RangeFilter';
import FiltersLoadingState from './FiltersLoadingState';
import { getMMT_HLD_OBJ } from '../../../../../common/utils/appUtils';
// import TransportOptionFilter from './TransportOptionFilter'; can be used later
import SearchWidget from './SearchWidget/SearchWidget';
import { isAgentLoggedIn } from '../../../../../common/utils/browserUtils';
import { AFFILIATES } from '../../../../../common/constants/appConstant';
import AffiliateSwitchToggle from './AffiliateSwitchToggle';

const HolidayLHS = ({
  filterTabActive,
  handleFilterTab,
  listingFilters,
  handleFilterChange,
  metadataIsLoading,
  packagesIsLoading,
  handleClearAllFilters,
}) => {
  const isAgentLogged = isAgentLoggedIn();
  const desktopCollapseFilter = getMMT_HLD_OBJ()?.desktopCollapseFilter || { 0: true, 1: true };
  const activeFilterSectionMobile = filterTabActive === 'filter' ? 'active' : '';

  const showOverlayFilterLoader = useMemo(
    () => !!listingFilters?.length && (metadataIsLoading || packagesIsLoading),
    [listingFilters?.length, metadataIsLoading, packagesIsLoading]
  );

  return (
    <div className={`listingLhs ${activeFilterSectionMobile}`} id="filter">
      <div className="stickyHeaderLHS">
        <h3>FILTERS</h3>
      </div>
      <div className="mbFilterHeader">
        <h3>
          <span className="icon mmt-cross" onClick={() => handleFilterTab('')} />
          Filter
        </h3>
        <span onClick={handleClearAllFilters} className="clearAllText">
          Clear All
        </span>
      </div>
      {metadataIsLoading && !listingFilters?.length ? (
        <div className="filterWrapper">
          <FiltersLoadingState />
        </div>
      ) : (
        <div className="filterWrapper">
          {isAgentLogged && <SearchWidget {...{ handleFilterChange }} />}
          {listingFilters
            ?.filter(filter => !filter.hidden)
            ?.map((filter, index) => {
              switch (filter.type) {
                case FILTER_TYPES.CHECKBOX:
                case FILTER_TYPES.MULTI_SELECT:
                case FILTER_TYPES.ICON_MULTI_SELECT:
                  return (
                    <ListFilter
                      handleFilterChange={handleFilterChange}
                      key={filter?.name}
                      filterData={filter}
                      showOverlayFilterLoader={showOverlayFilterLoader}
                      filterIndex={index}
                      isSearchSection={filter?.urlParam === 'places'}
                      isCollapsedOnInit={!desktopCollapseFilter[index]}
                    />
                  );
                case FILTER_TYPES.TABS_MULTI_SELECT:
                  return (
                    <HotelCategoryFilter
                      handleFilterChange={handleFilterChange}
                      key={filter?.name}
                      filterData={filter}
                      showOverlayFilterLoader={showOverlayFilterLoader}
                      filterIndex={index}
                      isCollapsedOnInit={!desktopCollapseFilter[index]}
                    />
                  );
                case FILTER_TYPES.DOUBLE_TAB_SINGLE_SELECT:
                  return (
                    <TilesFilter
                      handleFilterChange={handleFilterChange}
                      key={filter?.name}
                      filterData={filter}
                      showOverlayFilterLoader={showOverlayFilterLoader}
                      filterIndex={index}
                      isCollapsedOnInit={!desktopCollapseFilter[index]}
                    />
                  );
                case FILTER_TYPES.DROP_DOWN_SINGLE_SELECT:
                  return (
                    <ListFilter
                      singleSelect
                      handleFilterChange={handleFilterChange}
                      key={filter?.name}
                      filterData={filter}
                      showOverlayFilterLoader={showOverlayFilterLoader}
                      filterIndex={index}
                      isCollapsedOnInit={!desktopCollapseFilter[index]}
                    />
                  );
                case FILTER_TYPES.RANGE:
                  return (
                    <RangeFilter
                      handleFilterChange={handleFilterChange}
                      key={filter?.name}
                      filterData={filter}
                      showOverlayFilterLoader={showOverlayFilterLoader}
                      filterIndex={index}
                      isCollapsedOnInit={!desktopCollapseFilter[index]}
                    />
                  );
                default:
                  return null;
              }
            })}
          {isAgentLogged && (
            <div className="">
              <AffiliateSwitchToggle affiliate={AFFILIATES.INDIGO} />
              <AffiliateSwitchToggle affiliate={AFFILIATES.GOIBIBO} />
              <AffiliateSwitchToggle affiliate={AFFILIATES.MY_PARTNER} />
              <AffiliateSwitchToggle affiliate={AFFILIATES.HDFC_SB} />
              <AffiliateSwitchToggle affiliate={AFFILIATES.AIX} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ metadata, listingPackages }, props) => ({
  listingFilters: metadata?.listingFilters || [],
  metadataIsLoading: metadata?.isLoading,
  packagesIsLoading: listingPackages?.isLoading?.[props.activeTabId] ?? true,
});

export default connect(mapStateToProps)(HolidayLHS);
